var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { isOrganizationUserType } from "healthex-common/checkusertype";
import { isErr } from "healthex-common/result";
import { willNeverHappen } from "healthex-common/utils";
import { computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { validators } from "../Logic/Validators";
import { FormModel } from "./FormModel";
export var AccountSettingsProfileSaveType;
(function (AccountSettingsProfileSaveType) {
    AccountSettingsProfileSaveType["AVATAR"] = "AVATAR";
    AccountSettingsProfileSaveType["NAME"] = "NAME";
    AccountSettingsProfileSaveType["EMAIL"] = "EMAIL";
    AccountSettingsProfileSaveType["PHONE"] = "PHONE";
    AccountSettingsProfileSaveType["TITLE"] = "TITLE";
    AccountSettingsProfileSaveType["PROVIDER_ID"] = "PROVIDER_ID";
})(AccountSettingsProfileSaveType || (AccountSettingsProfileSaveType = {}));
const notProvidedText = "Not provided";
export class AccountSettingsProfileViewModel {
    constructor(container) {
        this.formModel = new FormModel({
            newAvatar: null,
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            title: "",
            providerId: "",
        }, ["newAvatar", "firstName", "lastName", "email", "phone", "title"]);
        this.isAvatarUploading = false;
        this.editingAvatar = false;
        this.editingName = false;
        this.editingEmailAddress = false;
        this.editingPhoneNumber = false;
        this.editingTitle = false;
        this.editingProviderId = false;
        this.authManager = container.authManager;
        this.organizationsManager = container.organizationsManager;
        this.loadCurrentInput();
    }
    get myOrganization() {
        return this.organizationsManager.myOrganization.value;
    }
    get showEmailSection() {
        if (this.myOrganization === NOT_LOADED || this.myOrganization === null)
            return false;
        return !this.myOrganization.ssoEnabled;
    }
    get userForAvatar() {
        if (this.authManager.userForAvatar === null)
            return null;
        return { ...this.authManager.userForAvatar, localAvatarFile: this.formModel.input.newAvatar };
    }
    get fullName() {
        return this.authManager.name;
    }
    get fullNameSectionText() {
        return this.fullName ? this.fullName : notProvidedText;
    }
    get emailSectionText() {
        return this.authManager.email ? this.authManager.email : notProvidedText;
    }
    get phoneSectionText() {
        return this.formModel.input.phone ? this.formModel.input.phone : notProvidedText;
    }
    get titleSectionText() {
        return this.formModel.input.title ? this.formModel.input.title : notProvidedText;
    }
    get orgName() {
        return this.authManager.orgName;
    }
    get showProviderIdSection() {
        return this.authManager.isProvider;
    }
    get phoneNumberEditingText() {
        return this.authManager.isDataUser
            ? "Use a phone number where your colleagues and patients can contact you."
            : "Use a phone number where approved researchers and patients can contact you.";
    }
    loadCurrentInput() {
        var _a, _b, _c, _d, _e, _f;
        this.formModel.input = {
            newAvatar: null,
            firstName: (_a = this.authManager.firstName) !== null && _a !== void 0 ? _a : "",
            lastName: (_b = this.authManager.lastName) !== null && _b !== void 0 ? _b : "",
            email: (_c = this.authManager.email) !== null && _c !== void 0 ? _c : "",
            phone: (_d = this.authManager.formattedPhone) !== null && _d !== void 0 ? _d : "",
            title: (_e = this.authManager.title) !== null && _e !== void 0 ? _e : "",
            providerId: (_f = this.authManager.providerId) !== null && _f !== void 0 ? _f : "",
        };
    }
    validateInput(saveType) {
        const { notBlank, validEmail, validPhone } = validators;
        const f = this.formModel;
        switch (saveType) {
            case AccountSettingsProfileSaveType.AVATAR:
                return true;
            case AccountSettingsProfileSaveType.NAME:
                f.clearError("firstName", "lastName");
                f.validateField("firstName", notBlank, "Enter a first name");
                f.validateField("lastName", notBlank, "Enter a last name");
                return !f.hasError("firstName", "lastName");
            case AccountSettingsProfileSaveType.EMAIL:
                f.clearError("email");
                f.validateField("email", notBlank, "Enter an email address");
                f.validateField("email", validEmail, "Enter a valid email address");
                return !f.hasError("email");
            case AccountSettingsProfileSaveType.PHONE:
                f.clearError("phone");
                f.validateField("phone", validPhone, "Enter a valid phone number");
                return !f.hasError("phone");
            case AccountSettingsProfileSaveType.TITLE:
                return true;
            case AccountSettingsProfileSaveType.PROVIDER_ID:
                f.clearError("providerId");
                f.validateField("providerId", notBlank, "Enter a unique provider ID");
                return !f.hasError("providerId");
        }
        return willNeverHappen(saveType);
    }
    getSaveInfo(saveType) {
        switch (saveType) {
            case AccountSettingsProfileSaveType.AVATAR:
                return { newAvatar: this.formModel.input.newAvatar };
            case AccountSettingsProfileSaveType.NAME:
                return { firstName: this.formModel.input.firstName, lastName: this.formModel.input.lastName };
            case AccountSettingsProfileSaveType.EMAIL:
                return { email: this.formModel.input.email };
            case AccountSettingsProfileSaveType.PHONE:
                return { phone: this.formModel.input.phone };
            case AccountSettingsProfileSaveType.TITLE:
                return { title: this.formModel.input.title };
            case AccountSettingsProfileSaveType.PROVIDER_ID:
                return { providerId: this.formModel.input.providerId };
        }
        return willNeverHappen(saveType);
    }
    postSaveCleanup(saveType) {
        switch (saveType) {
            case AccountSettingsProfileSaveType.AVATAR:
                this.isAvatarUploading = false;
                this.toggleEditingAvatar();
                break;
            case AccountSettingsProfileSaveType.NAME:
                this.toggleEditingName();
                break;
            case AccountSettingsProfileSaveType.EMAIL:
                this.toggleEditingEmailAddress();
                break;
            case AccountSettingsProfileSaveType.PHONE:
                this.toggleEditingPhoneNumber();
                break;
            case AccountSettingsProfileSaveType.TITLE:
                this.toggleEditingTitle();
                break;
            case AccountSettingsProfileSaveType.PROVIDER_ID:
                this.toggleEditingProviderId();
                break;
        }
    }
    async save(saveType) {
        if (!this.validateInput(saveType))
            return;
        if (!this.authManager.orgId || !this.authManager.id || !this.authManager.userType)
            return;
        if (saveType === AccountSettingsProfileSaveType.AVATAR)
            this.isAvatarUploading = true;
        if (!isOrganizationUserType(this.authManager.userType)) {
            return;
        }
        const result = await this.organizationsManager.editUser(this.authManager.orgId, this.authManager.id, {
            type: this.authManager.userType,
            ...this.getSaveInfo(saveType),
        });
        if (isErr(result)) {
            switch (result.error) {
                case "EMAIL_ALREADY_TAKEN":
                    this.formModel.addError("email", "Email address is already taken");
                    break;
                case "INVALID_EMAIL":
                    this.formModel.addError("email", "Enter a valid email address");
                    break;
                case "PROVIDER_ID_ALREADY_TAKEN":
                    this.formModel.addError("providerId", "Enter a unique provider ID");
                    break;
            }
        }
        else {
            await this.authManager.refreshTokenInfo();
            this.postSaveCleanup(saveType);
        }
    }
    toggleEditingAvatar() {
        this.editingAvatar = !this.editingAvatar;
        if (!this.editingAvatar) {
            this.formModel.input.newAvatar = null;
        }
    }
    toggleEditingName() {
        var _a, _b;
        this.editingName = !this.editingName;
        if (!this.editingName) {
            this.formModel.input.firstName = (_a = this.authManager.firstName) !== null && _a !== void 0 ? _a : "";
            this.formModel.input.lastName = (_b = this.authManager.lastName) !== null && _b !== void 0 ? _b : "";
            this.formModel.clearError("firstName", "lastName");
        }
    }
    toggleEditingEmailAddress() {
        var _a;
        this.editingEmailAddress = !this.editingEmailAddress;
        if (!this.editingEmailAddress) {
            this.formModel.input.email = (_a = this.authManager.email) !== null && _a !== void 0 ? _a : "";
            this.formModel.clearError("email");
        }
    }
    toggleEditingPhoneNumber() {
        var _a;
        this.editingPhoneNumber = !this.editingPhoneNumber;
        if (!this.editingPhoneNumber) {
            this.formModel.input.phone = (_a = this.authManager.formattedPhone) !== null && _a !== void 0 ? _a : "";
            this.formModel.clearError("phone");
        }
    }
    toggleEditingTitle() {
        var _a;
        this.editingTitle = !this.editingTitle;
        if (!this.editingTitle) {
            this.formModel.input.title = (_a = this.authManager.title) !== null && _a !== void 0 ? _a : "";
        }
    }
    toggleEditingProviderId() {
        var _a;
        this.editingProviderId = !this.editingProviderId;
        if (!this.editingProviderId) {
            this.formModel.input.providerId = (_a = this.authManager.providerId) !== null && _a !== void 0 ? _a : "";
        }
    }
    updateAvatar(file) {
        this.formModel.input.newAvatar = file;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AccountSettingsProfileViewModel.prototype, "isAvatarUploading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AccountSettingsProfileViewModel.prototype, "editingAvatar", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AccountSettingsProfileViewModel.prototype, "editingName", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AccountSettingsProfileViewModel.prototype, "editingEmailAddress", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AccountSettingsProfileViewModel.prototype, "editingPhoneNumber", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AccountSettingsProfileViewModel.prototype, "editingTitle", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AccountSettingsProfileViewModel.prototype, "editingProviderId", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "myOrganization", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "showEmailSection", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "userForAvatar", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "fullName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "fullNameSectionText", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "emailSectionText", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "phoneSectionText", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "titleSectionText", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "orgName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "showProviderIdSection", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AccountSettingsProfileViewModel.prototype, "phoneNumberEditingText", null);
